export default __webpack_public_path__ + "static/media/fan-on.c2628338.gif";